import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  modalBtnBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '1.43rem'
  },
  btnSize: {
    width: '10.71rem',
    marginRight: '0.71rem'
  }
});